import styled from 'styled-components';

export const UiDragSimpleTool = styled.div`
	display: block;
	width: 100%;
`;